module.exports = __webpack_public_path__ + "static/media/listing-page-maldives.97862ebb.jpg";